// Shared data
export const popularImages = [
  "https://images.unsplash.com/photo-1506929562872-bb421503ef21",
  "https://images.unsplash.com/photo-1503917988258-f87a78e3c995",
  "https://images.unsplash.com/photo-1506197603052-3cc9c3a201bd",
  "https://images.unsplash.com/photo-1506260408121-e353d10b87c7",
  "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4",
];

export const popularExperiences = [
  {
    category: "Adventure",
    title: "Mountain Hiking Tour",
    price: 30,
    rating: 4.8,
  },
  {
    category: "Food",
    title: "Local Food Tasting",
    price: 25,
    rating: 4.9,
  },
  {
    category: "Cultural",
    title: "Historical City Walk",
    price: 35,
    rating: 4.7,
  },
  {
    category: "Nature",
    title: "Waterfall Expedition",
    price: 40,
    rating: 4.9,
  },
  {
    category: "Relaxation",
    title: "Beachside Yoga",
    price: 20,
    rating: 4.6,
  },
];

export const coupleImg = "https://images.unsplash.com/photo-1518621736915-f3b1c41bfd00";
export const familyImg = "https://images.unsplash.com/photo-1600880292203-757bb62b4baf";
export const adventureImg = "https://images.unsplash.com/photo-1530549387789-4c1017266635";
export const luxuryImg = "https://images.unsplash.com/photo-1566073771259-6a8506099945";

export const discoverPackages = [
  {
    package: "3-days Kigali Tour",
    location: "Kigali, Rwanda",
    price: 450,
    rating: 4.7,
  },
  {
    package: "5-days Safari Adventure",
    location: "Serengeti, Tanzania",
    price: 1200,
    rating: 4.9,
  },
  {
    package: "Weekend Beach Getaway",
    location: "Zanzibar, Tanzania",
    price: 350,
    rating: 4.8,
  },
  {
    package: "7-days Cultural Journey",
    location: "Cape Town, South Africa",
    price: 950,
    rating: 4.6,
  },
  {
    package: "2-days Wine Tasting",
    location: "Stellenbosch, South Africa",
    price: 280,
    rating: 4.5,
  },
  {
    package: "3-days Kigali Tour",
    location: "Kigali, Rwanda",
    price: 450,
    rating: 4.7,
  },
  {
    package: "5-days Safari Adventure",
    location: "Serengeti, Tanzania",
    price: 1200,
    rating: 4.9,
  },
  {
    package: "Weekend Beach Getaway",
    location: "Zanzibar, Tanzania",
    price: 350,
    rating: 4.8,
  },
  {
    package: "7-days Cultural Journey",
    location: "Cape Town, South Africa",
    price: 950,
    rating: 4.6,
  },
  {
    package: "2-days Wine Tasting",
    location: "Stellenbosch, South Africa",
    price: 280,
    rating: 4.5,
  },
];

export const discoverImages = [
  "https://images.unsplash.com/photo-1563841930606-67e2bce48b78",
  "https://images.unsplash.com/photo-1509316785289-025f5b846b35",
  "https://images.unsplash.com/photo-1544551763-46a013bb70d5",
  "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4",
  "https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb",
];
